import { Component, OnInit, OnDestroy, inject, Inject, PLATFORM_ID } from '@angular/core';
import {  isPlatformBrowser } from '@angular/common';
import { RouterOutlet } from '@angular/router';
import { NotificationsComponent } from './shared/components/notifications/notifications.component';
import { NotificationEstablishmentComponent } from './shared/components/notification-establishment/notification-establishment.component';
import { ModalViewProductComponent } from './features/establishment-main/components/modal-view-product/modal-view-product.component';
import { ProductModalService } from './core/service/product-modal.service';
import { GeolocationService } from './core/service/geolocation/geolocation.service';
import { Subscription } from 'rxjs';
import { Product } from './features/establishment-main/components/products/interfaces/products.interface';
import { NoHasInternetComponent } from './layouts/components/no-has-internet/no-has-internet.component';
import { ProductData } from './features/establishment-main/components/list-products/interfaces/list-products-new.interface';
import { DevolucionDineroComponent } from './features/devolucion-dinero/devolucion-dinero.component';
import { DevolucionDineroModalService } from './features/devolucion-dinero/service/devolucion-dinero-modal.service';
import { AutoUpdateService } from './core/service/updates/auto-update.service';
import { InactivityService } from './core/service/inactivity.service';
import { AuthService } from './core/service/auth.service';
import { PerfilTourService } from './core/service/driver-tour/perfil-tour.service';
import { ConfettiComponent } from './shared/confetti/confetti.component';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [
    RouterOutlet,
    NotificationsComponent,
    NotificationEstablishmentComponent,
    ModalViewProductComponent,
    NoHasInternetComponent,
    DevolucionDineroComponent,
    ConfettiComponent
],
  templateUrl: './app.component.html',
  styleUrl: './app.component.css'
})
export class AppComponent implements OnInit, OnDestroy {
  title = 'marketplace';
  showProductModal = false;
  selectedProduct: Product | null | ProductData= null;
  private subscription = new Subscription();
  authService = inject(AuthService);
  perfilTourService = inject(PerfilTourService);
  constructor(
    private productModalService: ProductModalService,
    private geolocationService: GeolocationService,
    private devolucionDineroModalService: DevolucionDineroModalService,
    private inactivityService: InactivityService,
    @Inject(PLATFORM_ID) private platformId: Object
  ) {
  inject(AutoUpdateService); // Solo inyectarlo para que se inicialice


  }

  ngOnInit(): void {
    // Iniciar monitoreo de inactividad (15 minutos por defecto)
    this.inactivityService.startMonitoring();

    // Suscribirse a los cambios en el estado del modal
    this.subscription.add(
      this.productModalService.showModal$.subscribe(show => {
        this.showProductModal = show;
      })
    );

    // Suscribirse a los cambios en el producto seleccionado
    this.subscription.add(
      this.productModalService.product$.subscribe(product => {
        this.selectedProduct = product;
      })
    );

    if (isPlatformBrowser(this.platformId)) {
      this.initializeGeolocation();
    }
    // Mostrar el tour de perfil si el usuario está autenticado y el tour no está activo
    // this.showTourPerfil();
  }

  ngOnDestroy(): void {
    // Limpiar suscripciones al destruir el componente
    this.subscription.unsubscribe();
    this.inactivityService.stopMonitoring();
  }

  closeProductModal(): void {
    this.productModalService.closeModal();
  }

  /**
   * Inicializa la geolocalización automáticamente al cargar la aplicación
   */
  private initializeGeolocation(): void {
    // Verificar si ya existe una ubicación reciente
    if (this.geolocationService.isLocationRecent()) {
      return;
    }

    // Verificar permisos de geolocalización
    this.geolocationService.checkLocationPermission()
      .then(permission => {
        if (permission === 'granted') {
          // Si ya tenemos permisos, obtener la ubicación
          this.requestLocation();
        } else if (permission === 'prompt') {
          this.requestLocation();
        } else {

        }
      })
      .catch(error => {
        // Intentar obtener la ubicación de todas formas
        this.requestLocation();
      });
  }

  /**
   * Solicita la ubicación actual del usuario
   */
  private requestLocation(): void {
    this.subscription.add(
      this.geolocationService.getCurrentLocation().subscribe({
        next: (location) => {

        },
        error: (error) => {
          // En caso de error, intentar guardar Puebla Centro como respaldo
          this.geolocationService.setPueblaCentroAsDefault();
        }
      })
     );
   }

  showTourPerfil(): void {
    if (this.isAuthenticated && !this.perfilTourService.isActive()) {
        this.perfilTourService.showTourPerfil();


    }
  }

  get isAuthenticated(): boolean {
    return this.authService.isLoggedIn();
  }


 }
